import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { PLANS } from '../../analytics';
import { COUPONS } from '../../analytics/coupons';
import { setEventData } from '../store/events';
import { setCouponDetails, setPlan, setPlanDetails } from '../store/plans';
import { analyticsMinorUnitsFromPrice } from '../utils';

export const useSetPlan = () => {
  const dispatch = useDispatch();

  return useCallback(
    (id: string, coupon = '', extraInfo = {}) => {
      dispatch(setPlan(id));

      const updatedPlanDetails = { ...PLANS[id], ...extraInfo };
      dispatch(setPlanDetails(updatedPlanDetails));

      const couponPrice = COUPONS[coupon] || 0;
      dispatch(setCouponDetails({ couponPrice, couponName: coupon }));

      const { productId, duration, description, periodPrice, price, currency } = updatedPlanDetails;
      dispatch(
        setEventData({
          value: analyticsMinorUnitsFromPrice(price, currency),
          currency: currency || 'USD',
          price,
          duration,
          description,
          periodPrice: +(periodPrice - couponPrice).toFixed(2),
          product_id: productId,
        }),
      );
    },
    [dispatch],
  );
};
